import React, { useEffect, useState } from "react";
import "../styles/AddDeliveryComp.css";
import { useNavigate } from "react-router-dom";
import BusinessHubHeader from "../components/BusinessHubHeader";
import BackArrow from "../icons/BusinessHub/BackArrow";
import CompRegInput from "./CompRegInput";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon";
import { userService } from "../services/userService";
import companyController from "../controllers/companyController";
import { toast } from "react-toastify";
import Utils from "../utils/Utils";
import getUser from "../controllers/userController";
import userController from "../controllers/userController";
import { useLocation } from "react-router-dom";

function AddDeliveryComp() {
  const jwt = userService.getUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedType, userType } = location.state;
  const [childDTO, setChildDTO] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [termsPop, setTermsPop] = useState(false);
  const [ischecked, setIschecked] = useState(false);

  const handleSubmit = async () => {
    const parsed = Utils.parseJwt(jwt);
    const companyRegisterRequest = {
      companies: [
        {
          // businessProfileID: userService.getBPID(),
          // companyID: userService.getCompID(),
          companyName: childDTO.companyName,
          companyType: "PRIMARY",
          customObject: [
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "ID",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO.documents.ownerIDPassport.base64),
              extension: childDTO.documents.ownerIDPassport.name
                .split(".")
                .pop(),
              objectName: childDTO.documents.ownerIDPassport.name,
              userName: parsed.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "POLICE_CLEARANCE",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(
                childDTO.documents.policeCertificate.base64,
              ),
              extension: childDTO.documents.policeCertificate.name
                .split(".")
                .pop(),
              objectName: childDTO.documents.policeCertificate.name,
              userName: parsed.username,
            },
            {
              attachmentStatus: "DEFAULT",
              attachmentType: "PROOF_OF_LEAGALITY",
              countryName: getUser?.data?.countryOfResidence?.trim()
                ? getUser.data.countryOfResidence
                : "ZAHLE",
              customPath: "string",
              data: Utils.padBase64(childDTO.documents.legalProof?.base64),
              extension: childDTO.documents.legalProof?.name.split(".").pop(),
              objectName: childDTO.documents.legalProof?.name,
              userName: parsed.username,
            },
          ],
          registrationNumber: childDTO.taxNumber,
          termsAndConditionAccepted: ischecked,
          taxNumber: childDTO.taxNumber,
          userID: parsed.id,
          userType: "DELIVERY_COMPANY",
        },
      ],
    };

    try {
      const response = await companyController.CompanyRegistration({
        companyRegisterRequest: companyRegisterRequest,
        Authorization: jwt,
      });
      if (Utils.isSuccessResponse(response)) {
        toast.success("Registered successfully!");
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Company registration failed", err);
    }
    // setSubmitted(true);
  };
  useEffect(() => {
    if (termsPop) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [termsPop]);
  return (
    <div>
      <div className="create-comp-page-header">
        <BusinessHubHeader />
      </div>

      <div className="create-comp-content-main-container">
        {submitted && (
          <div className="edit-role-popup-container">
            <div
              className="edit-role-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-role-popup-content">
                <div className="edit-role-successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="edit-role-successfully-added-text">
                  Verification in Progress
                </div>
                <div className="comp-reg-data-review-note">
                  We are currently reviewing your legal documents, tax number,
                  and ID. Until your information is fully verified, your access
                  will remain limited as a guest. <br />
                  <b>
                    We will notify you once your account is approved and
                    activated.
                  </b>
                </div>
                <div
                  className="edit-role-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Go to Business Overview
                </div>
              </div>
            </div>
          </div>
        )}

        {termsPop && (
          <div className="comp-create-popup-container">
            <div
              className="comp-create-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="comp-create-popup-content">
                <div className="comp-create-successfully-added-text">
                  Terms and Conditions
                </div>
                <div className="comp-create-successfully-added-icon">
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Duis autem vel eum iriure
                  dolor in hendrerit in vulputate velit esse molestie consequat,
                  vel illum dolore eu feugiat nulla facilisis at vero eros et
                  accumsan et iusto odio dignissim qui blandit praesent luptatum
                  zzril delenit augue duis dolore te feugait nulla facilisi.
                  Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
                  diam nonummy nibh euismod tincidunt ut laoreet dolore magna
                  aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                  nostrud exerci tation ullamcorper suscipit lobortis nisl ut
                  aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit, sed diam nonummy nibh euismod
                  tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
                  wisi enim ad minim veniam, quis nostrud exerci tation
                  ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
                  consequat.
                </div>
                <div
                  className="comp-create-successfully-added-action-button"
                  onClick={() => {
                    setTermsPop(false);
                    setIschecked(true);
                  }}
                >
                  Accept
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Form */}
        <div className="create-comp-content-container">
          <div className="create-comp-data-header">
            <div className="create-comp-header-navigation">
              <div
                className="create-comp-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", { state: { active: "A" } })
                }
              >
                <BackArrow />
              </div>
              <div className="create-comp-header-navigation-text">
                Back to Business Overview
              </div>
            </div>

            <div className="create-comp-header-text">
              <div className="create-comp-header-title">
                Add Delivery Company
              </div>
              <div className="create-comp-header-text-note">
                Fill in all required fields and upload the necessary documents
              </div>
            </div>
          </div>

          <div className="create-comp-body">
            <div className="comp-reg-window-container">
              <CompRegInput onDataChange={setChildDTO} />

              <div className="comp-reg-info-input-body-doc-agree">
                <input
                  style={{ cursor: "pointer" }}
                  type="checkbox"
                  checked={ischecked}
                  onChange={(e) => setIschecked(e.target.checked)}
                />
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setTermsPop(true)}
                >
                  I agree with the terms and conditions
                </div>
              </div>

              <div className="comp-reg-info-input-footer">
                {!termsPop && (
                  <div
                    className="comp-reg-submit-action-button"
                    onClick={handleSubmit}
                    style={{
                      opacity: ischecked ? 1 : 0.5,
                      pointerEvents: ischecked ? "auto" : "none",
                      cursor: ischecked ? "pointer" : "not-allowed",
                    }}
                  >
                    Submit
                  </div>
                )}

                <div
                  className="comp-reg-cancel-action-button"
                  onClick={() =>
                    navigate("/user-management", { state: { active: "A" } })
                  }
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddDeliveryComp;
